// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b-attachment_document {\n  border-radius: 2px;\n}\n.b-attachment_document button {\n  padding: 5px 16px;\n  border-radius: 6px;\n}", ""]);
// Exports
module.exports = exports;
